import React from "react";
import AppRoutes from "./routes/AppRoutes.jsx";
import SessionManager from "./components/SessionManager/SessionManager.jsx";
// Analytics - env-var-controlled, mounts no-op if IDs aren't set. Must sit
// inside <BrowserRouter> (see index.js) because it reads useLocation() to fire
// a GA4 page_view per SPA route change.
import Analytics from "./seo/Analytics.jsx";
// Remembers a friend's ?ref= code until signup (see utils/referral.js). Renders nothing.
import ReferralCapture from "./components/referral/ReferralCapture.jsx";

const App = () => (
  <>
    <SessionManager />
    <Analytics />
    <ReferralCapture />
    <AppRoutes />
  </>
);

export default App;
